export enum CollectionPaths {
    users = 'users'
}